/** @jsx jsx */
import { jsx } from 'theme-ui';
import React, { useEffect } from 'react';
import hhmmss from 'hhmmss';
import useDeck from '../hooks/use-deck';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ticker;
export var Timer = function Timer(props) {
  var _useDeck = useDeck(),
      setState = _useDeck.setState,
      _useDeck$timer = _useDeck.timer,
      timer = _useDeck$timer === void 0 ? false : _useDeck$timer,
      _useDeck$seconds = _useDeck.seconds,
      seconds = _useDeck$seconds === void 0 ? 0 : _useDeck$seconds;

  useEffect(function () {
    var tick = function tick() {
      if (!timer) return;
      setState({
        seconds: seconds + 1
      });
    };

    ticker = setInterval(tick, 1000);
    return function () {
      clearInterval(ticker);
    };
  }, [timer, seconds]);

  var toggle = function toggle() {
    setState({
      timer: !timer
    });
  };

  var reset = function reset() {
    setState({
      seconds: 0
    });
  };

  return jsx(React.Fragment, null, jsx("button", {
    onClick: reset,
    disabled: !seconds,
    title: "Reset timer",
    sx: {
      mx: 1
    }
  }, "Reset"), ' ', jsx("button", {
    title: timer ? 'Stop timer' : 'Start timer',
    onClick: toggle,
    sx: {
      mx: 1
    }
  }, timer ? 'Stop' : 'Start'), ' ', hhmmss(seconds));
};
export default Timer;